import { userClient } from '../config/api';
import {
  ApiResponse,
  BankUser,
  CreateBankUserRequest,
  UpdateBankUserRequest,
  GetAllBankUsersParams,
} from './types/user.types';
import { apiErrorHandler } from '@/helpers/apiErrorHandler';

export class BankUserService {
  private readonly basePath = '/api/users/bank';

  createBankUser = async (data: CreateBankUserRequest): Promise<BankUser> => {
    try {
      const response = await userClient.post<ApiResponse<BankUser>>(this.basePath, data);

      if (!response.data || !response.data.success || !response.data.data) {
        throw new Error(response.data?.errorMessage || 'Error creating bank user');
      }

      return response.data.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Error creating bank user');
    }
  }

  getAllBankUsers = async (params?: GetAllBankUsersParams): Promise<BankUser[]> => {
    try {
      const response = await userClient.get<ApiResponse<any>>(this.basePath, {
        params: {
          page: 1,
          pageSize: 1000,
          ...params
        },
      });

      if (!response.data || !response.data.success) {
        throw new Error(response.data?.errorMessage || 'Error fetching bank users');
      }

      const data = response.data.data;
      if (data && typeof data === 'object' && 'data' in data) {
        return data.data || [];
      }

      return data || [];
    } catch (error: unknown) {
      apiErrorHandler(error, 'Error fetching bank users');
    }
  }

  getBankUserById = async (id: string): Promise<BankUser> => {
    try {
      const response = await userClient.get<ApiResponse<BankUser>>(`${this.basePath}/${id}`);

      if (!response.data || !response.data.success || !response.data.data) {
        throw new Error(response.data?.errorMessage || 'Error fetching bank user');
      }

      return response.data.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Error fetching bank user');
    }
  }

  updateBankUser = async (id: string, data: UpdateBankUserRequest): Promise<BankUser> => {
    try {
      const response = await userClient.put<ApiResponse<BankUser>>(
        `${this.basePath}/${id}`,
        data
      );

      if (!response.data || !response.data.success || !response.data.data) {
        throw new Error(response.data?.errorMessage || 'Error updating bank user');
      }

      return response.data.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao atualizar usuário do banco');
    }
  }

  deleteBankUser = async (id: string): Promise<void> => {
    try {
      const response = await userClient.delete<ApiResponse<void>>(`${this.basePath}/${id}`);

      if (response.data && !response.data.success) {
        throw new Error(response.data?.errorMessage || 'Error deleting bank user');
      }
    } catch (error: unknown) {
      apiErrorHandler(error, 'Error deleting bank user');
    }
  }
}

export const bankUserService = new BankUserService();
